var map = {
	"./ar.png": "./src/assets/landing/spreadsheet/ar.png",
	"./da.png": "./src/assets/landing/spreadsheet/da.png",
	"./de.png": "./src/assets/landing/spreadsheet/de.png",
	"./en.png": "./src/assets/landing/spreadsheet/en.png",
	"./es-419.png": "./src/assets/landing/spreadsheet/es-419.png",
	"./es.png": "./src/assets/landing/spreadsheet/es.png",
	"./fr.png": "./src/assets/landing/spreadsheet/fr.png",
	"./it.png": "./src/assets/landing/spreadsheet/it.png",
	"./ja.png": "./src/assets/landing/spreadsheet/ja.png",
	"./nb.png": "./src/assets/landing/spreadsheet/nb.png",
	"./nl.png": "./src/assets/landing/spreadsheet/nl.png",
	"./pl.png": "./src/assets/landing/spreadsheet/pl.png",
	"./pt.png": "./src/assets/landing/spreadsheet/pt.png",
	"./sv.png": "./src/assets/landing/spreadsheet/sv.png",
	"./tr.png": "./src/assets/landing/spreadsheet/tr.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/landing/spreadsheet sync recursive ^\\.\\/.*\\.png$";